import { put, takeLatest } from "redux-saga/effects";
import { thamSoHeThongChucNangApi } from "../../../api/category/thamSoHeThongChucNangApi";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { eThamSoHeThongChucNangActionIds, IThamSoHeThongChucNangActionTypes } from "../../action-types/category/IThamSoHeThongChucNangActions";
import { rootActions } from "../../actions/rootActions";
import { thamSoHeThongApi } from "../../../api/category/thamSoHeThongApi";
import { IThamSoHeThongUpdateActiveStatus } from "../../../model/request/category/IThamSoHeThongUpdateActiveStatus";
import { IThamSoHeThongUpdateRequest } from "../../../model/request/category/IThamSoHeThongUpdateRequest";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";


export function* thamSoHeThongChucNangSaga() : any {
    yield takeLatest(eThamSoHeThongChucNangActionIds.SELECT_BY_CHUC_NANG, loadWoker);
    yield takeLatest(eThamSoHeThongChucNangActionIds.UPDATE_ACTIVE_STATUS_START, updateActiveStatusWorker);
    yield takeLatest(eThamSoHeThongChucNangActionIds.UPDATE_THAM_SO_START, updateThamSoWorker);
}

function* loadWoker(action: IThamSoHeThongChucNangActionTypes): any {
    const ma_chuc_nang = action.payload as string;
     const response: IBaseResponse = yield thamSoHeThongChucNangApi.SelectByChucNang(ma_chuc_nang);
     console.log("🚀 ~ function*loadWoker ~ response:", response)
     if (response.is_success)   
     {
        yield put(rootActions.category.thamSoHeThongChucNang.SELECT_BY_CHUC_NANG_SUCCESS(response.data));
     }
     else
     {
        yield put(rootActions.category.thamSoHeThongChucNang.SELECT_BY_CHUC_NANG_ERROR(response.message || "Lỗi không xác định"));
     }
}

function* updateActiveStatusWorker(action: IThamSoHeThongChucNangActionTypes): any {
    const payload = action.payload as IThamSoHeThongUpdateActiveStatus;
    const response: IBaseResponse = yield thamSoHeThongApi.UpdateActiveStatus(payload);
    if (response.is_success) {
        yield put(rootActions.category.thamSoHeThongChucNang.UPDATE_ACTIVE_STATUS_SUCCESS(payload));
    } else {
        yield put(rootActions.category.thamSoHeThongChucNang.UPDATE_ACTIVE_STATUS_ERROR(response.message || "Lỗi không xác định"));
    }
}


function* updateThamSoWorker(action: IThamSoHeThongChucNangActionTypes): any {
    const payload = action.payload as IThamSoHeThongUpdateRequest;
    const response: IBaseResponse = yield thamSoHeThongApi.UpdateThamSo(payload);
    if (response.is_success) {
        yield put(rootActions.category.thamSoHeThongChucNang.UPDATE_THAM_SO_SUCCESS( toLowerCaseDeep(response.data)));
    } else {
        yield put(rootActions.category.thamSoHeThongChucNang.UPDATE_THAM_SO_ERROR(response.message || "Lỗi không xác định"));
    }
}